import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "./Sidebar";
import { Divider, Paper, Typography,LinearProgress, Backdrop, CircularProgress } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import CountUp from "react-countup";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import base from '../src/base.json'
import GroupsIcon from '@mui/icons-material/Groups';

const drawerWidth = 80;
export class Dashboard extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      tab : 'one',
      is_loader_open : false,


/////// counters ///
               total_cust_count : 0,
                total_ord_count : 0,
                vendor_count :0,
                frenchise_count  : 0





    
    }
  }
 



componentDidMount(){
fetch(`${base.base_url}/admin/adminAnalytics`, {
      headers:{
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "get",
        }).then(function(response) {
          return response.json();
        })
        .then((data)=> {
         this.setState({
                total_cust_count : data.total_cust_count,
                total_ord_count : data.total_ord_count,
                vendor_count : data.vendor_count,
                frenchise_count  : data.frenchise_count
         })
        });
      
}






  render() {


    return (
  
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
<Box sx={{height:'100%',width:'100%'}}>

{
  /// header data
}
<Box  sx={{height:47,width:'100%',backgroundColor:'#fff',borderRadius:0,mt:0.2,borderBottom:0.5,borderBottomColor:'#dddddd'}}>
<Tabs
  value={this.state.tab}
  onChange={this.handleChange}
  aria-label="wrapped label tabs example"
>
  <Tab
    value="one"
    sx={{textTransform:'none',fontWeight:'500',fontSize:15}}
    label="Dashboard"
    wrapped
  />
</Tabs>
</Box>



{
  /// grid container
}
<Box sx={{paddingLeft:3,paddingRight:3,paddingTop:2,display:this.state.is_loader_open?'none':'block'}}>

<Box>
<Grid container spacing={1}>
  <Grid size={{xs:12,sm:6,md:2.4}}>

    <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom, #430089, #ff9f43)'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TOTAL VENDOR</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> <CountUp start={0} end={this.state.vendor_count}  /></Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:40,backgroundColor:'#fff0d3',borderRadius:3,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
        <Diversity3Icon sx={{height:35,width:35,color:'#ffb621'}}/>
       </Box>
     </Box>
    </Box>
    </Paper>

  </Grid>
  <Grid size={{xs:12,sm:6,md:2.4}}>
  <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom, #430089,rgb(104, 7, 55))'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TOTAL FRENCHISE</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> <CountUp start={0} end={this.state.frenchise_count}  /></Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:40,backgroundColor:'#f3d7e6',borderRadius:3,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
        <LibraryBooksIcon sx={{height:35,width:35,color:'#ab266c'}}/>
       </Box>
     </Box>
    </Box>
    </Paper>
  </Grid>
  <Grid size={{xs:12,sm:6,md:2.4}}>
  <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom,rgb(67, 5, 133),rgb(74, 150, 59))'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TOTAL CUSTOMER</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> <CountUp start={0} end={this.state.total_cust_count}  /></Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:40,backgroundColor:'#cef0ca',borderRadius:3,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
        <GroupsIcon sx={{height:35,width:35,color:'#007c00'}}/>
       </Box>
     </Box>
    </Box>
    </Paper>
  </Grid>
  <Grid size={{xs:12,sm:6,md:2.4}}>
  <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom,rgb(24, 2, 48),rgb(103, 226, 232))'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TOTAL ORDERS</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> <CountUp start={0} end={this.state.total_ord_count}  /></Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:40,backgroundColor:'#d9f5f6',borderRadius:3,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
        <VolunteerActivismIcon sx={{height:35,width:35,color:'#01cfe6'}}/>
       </Box>
     </Box>
    </Box>
    </Paper> 
  </Grid>
  <Grid size={{xs:12,sm:6,md:2.4}}>
  <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom,rgb(9, 1, 39),rgb(242, 148, 148))'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TODAY TOTAL ORDERS</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> <CountUp start={0} end={0}  /></Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:40,backgroundColor:'#f5d0d1',borderRadius:3,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
        <AccountBalanceOutlinedIcon sx={{height:35,width:35,color:'red'}}/>
       </Box>
     </Box>
    </Box>
    </Paper>
  </Grid>
</Grid>
</Box>



{
  //// group division 
}

<Box sx={{mt:2,mb:2,display:'none'}}>

<Grid container spacing={3}>

<Grid size={{xs:12,sm:12,md:8}}>
<Box sx={{height:600,width:'100%',backgroundColor:'pink'}}>




</Box>
</Grid>
<Grid size={{xs:12,sm:12,md:4}}>
<Box sx={{height:600,width:'100%',backgroundColor:'red'}}>




</Box>
</Grid>

</Grid>


</Box>



































</Box>
</Box>

        </Box>




<Backdrop
  sx={(theme) => ({ color: '#fff',backgroundColor:'transparent',  zIndex: theme.zIndex.drawer + 1})}
  open={this.state.is_loader_open}
  onClick={this.handleClose}
>
<CircularProgress sx={{color:"#008ffb"}} />
</Backdrop>



      </Box>
   
    );
  }
}

export default Dashboard;
